import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../../components/Layout";
import { useLang } from "../../utils/LangContext";

import localStorageHelper from "../../utils/localStorageHelper";
import { fetchData } from "../../utils/apiUtils";

function PrivateGameChoice() {
  const { t } = useLang();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash");

  // initialize from localStorage if present
  const [game, setGame] = useState(() => localStorageHelper.getItem("game"));

  useEffect(() => {
    if (!hash) return; // no hash → skip

    const loadGameInfo = async () => {
      try {
        const data = await fetchData(
          "/api/v1/game/info?game_hash=" + encodeURIComponent(hash)
        );
        if (data) {
          localStorageHelper.setItem("game", data);
          setGame(data);
        }
      } catch (err) {
        console.error("Failed to load game info:", err);
      }
    };

    loadGameInfo();
  }, [hash]);

  if (!game) {
    return (
      <Layout>
        <div className="text-center">
          <h1 className="fw-bold">{t("Loading game…")}</h1>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="text-center">
        <h1 className="fw-bold">
          {t("Start Game")}: {game.name}
        </h1>
        <div className="mt-4">
          <Link to="/private/create-team" className="btn btn-primary m-2">
            {t("Create New Team")}
          </Link>
          <Link to="/private/join-team" className="btn btn-secondary m-2">
            {t("Join Team")}
          </Link>
        </div>
      </div>
    </Layout>
  );
}

export default PrivateGameChoice;